import Paging from "./Paging";
import ListItem from "./ListItem";
import{useState, useEffect} from 'react';
import { useSearchParams } from "react-router";
import { api } from 'server-api';
import { Link } from "react-router";

export default function List({type, viewUrl}){
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(0);
  const [last, setLast] = useState(0);
  const limit = 6;

  const [searchParams] = useSearchParams();
  const currentPage= searchParams.get('page')? Number(searchParams.get('page')):1;
  if(page !== currentPage)
    setPage(currentPage);
  
  useEffect(()=>{
    const url = `/posts?type=${type}&page=${page}`;
    console.log('url', url);
    const getData = async()=>{
      try{
      let res = await api.get(url);
      setPosts(res.data.rows);
      setLast(Math.ceil(res.data.count/limit));
      }catch(error){
        console.error(error);
        setPosts([]);
        setLast(0);
      }
    }
    getData();
  },[page, type]);

  return (
    <div className="flex flex-col items-center my-5">
      <div className="flex flex-row justify-evenly lg:justify-start flex-wrap  lg:w-[1200px]">
        {posts.map((post, i)=>{
          return (
            <Link key={i}  to={`${viewUrl}/${post.id}`}>
              <ListItem {...post} />
            </Link>
          );
        })}
      </div>
      <Paging current={currentPage} last={last} baseurl={``}/>
    </div>
  );
}